import { useEffect, useState } from "react";
import { Col, Form, FormFeedback, Input, Label, Row } from "reactstrap";
import { useCommonDataFindAllQuery, useMeasurementDamCreateMutation, useMeasurementDamFindAllQuery, useMeasurementDamUpdateMutation } from "store";
import * as Yup from "yup";
import { useFormik } from "formik";
import Spinners from "Components/Common/Spinner";
import { Link, useParams } from "react-router-dom";
import Switch from "react-switch";
import measurementSvg from "../../../assets/images/svg/measurement.svg"
import Flatpickr from "react-flatpickr";

const Measurement = () => {
  const { id } = useParams();
  const [isLoading, setLoading] = useState(true)
  const { data, error, isFetching } = useMeasurementDamFindAllQuery(`?dam_id=${id}`);
  const [measurementDamCreate, measurementDamCreateResult] = useMeasurementDamCreateMutation();
  const [measurementDamUpdate, measurementDamUpdateResult] = useMeasurementDamUpdateMutation();
  const [measurementDam, setMeasurementDam] = useState<any>();

  const [measurementList, setMeasurementList] = useState<any>();

  const [meaCount, setMeaCount] = useState<any>();

  const [is_used, setIs_usedBoolean] = useState<boolean>(false);
  const [is_newCreated, setIs_newCreated] = useState<boolean>(false);


  useEffect(() => {
    if (measurementDam === undefined) {
      setLoading(true);
    } else {
      setLoading(false);
    }
    setMeasurementList(data?.data);
    setMeaCount(data?.data?.length)
    const tempIs_used = measurementDam !== null ? measurementDam?.is_used : false;
    setIs_usedBoolean(tempIs_used)
  }, [id, data, measurementDam])


  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      id: measurementDam?.id,
      dam_id: measurementDam?.dam_id,
      dam_code: measurementDam?.dam_code,
      measure_date: measurementDam?.measure_date,
      design: measurementDam?.design,
      fiction: measurementDam?.fiction,
      flooddam_head_degree: measurementDam?.flooddam_head_degree,
      flooddam_footer_degree: measurementDam?.flooddam_footer_degree,
      embankment_type: measurementDam?.embankment_type,
      embankment_design: measurementDam?.embankment_design,
      flooddrain_type: measurementDam?.flooddrain_type,
      length: measurementDam?.length,
      heigth: measurementDam?.heigth,
      floodwater_canal_design: measurementDam?.floodwater_canal_design,
      irrigation_canal_length: measurementDam?.irrigation_canal_length,
      irrigation_canal_capacity: measurementDam?.irrigation_canal_capacity,
      canal_design: measurementDam?.canal_design,
      head_construction_design: measurementDam?.head_construction_design,
      maincanal_construction_num: measurementDam?.maincanal_construction_num,
      is_used: measurementDam?.is_used,
      usage_information: measurementDam?.usage_information,

      report_autor: measurementDam?.report_autor,
      report_name: measurementDam?.report_name,
      report_code: measurementDam?.report_code,
    },
    validationSchema: Yup.object({
      dam_code: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      measure_date: Yup.date().typeError("Он сар өдөр оруулна уу").required("Утга оруулна уу !"),
      design: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      fiction: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      flooddam_head_degree: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      flooddam_footer_degree: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      embankment_type: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      embankment_design: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      flooddrain_type: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      length: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      heigth: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      floodwater_canal_design: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),

      irrigation_canal_length: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      irrigation_canal_capacity: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),

      canal_design: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      head_construction_design: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      maincanal_construction_num: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      usage_information: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),

      report_autor: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      report_name: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      report_code: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
    }),
    onSubmit: (values: any) => {
      if (is_newCreated === false) {
        const updateList = {
          id: measurementDam?.id,
          dam_id: values?.dam_id,
          dam_code: values?.dam_code,
          measure_date: values?.measure_date,
          design: values?.design,
          fiction: values?.fiction,
          flooddam_head_degree: values?.flooddam_head_degree,
          flooddam_footer_degree: values?.flooddam_footer_degree,
          embankment_type: values?.embankment_type,
          embankment_design: values?.embankment_design,
          flooddrain_type: values?.flooddrain_type,
          length: values?.length,
          heigth: values?.heigth,
          floodwater_canal_design: values?.floodwater_canal_design,
          irrigation_canal_length: values?.irrigation_canal_length,
          irrigation_canal_capacity: values?.irrigation_canal_capacity,
          canal_design: values?.canal_design,
          head_construction_design: values?.head_construction_design,
          maincanal_construction_num: values?.maincanal_construction_num,
          is_used: is_used === undefined ? false : is_used,
          usage_information: values?.usage_information,

          report_autor: values?.report_autor,
          report_name: values?.report_name,
          report_code: values?.report_code,

        }

        measurementDamUpdate(updateList);
      } else {
        const newList = {
          dam_id: id,
          dam_code: values["dam_code"],
          measure_date: values["measure_date"],
          design: values["design"],
          fiction: values["fiction"],
          flooddam_head_degree: values["flooddam_head_degree"],
          flooddam_footer_degree: values["flooddam_footer_degree"],
          embankment_type: values["embankment_type"],
          embankment_design: values["embankment_design"],
          flooddrain_type: values["flooddrain_type"],
          length: values["length"],
          heigth: values["heigth"],
          floodwater_canal_design: values["floodwater_canal_design"],
          irrigation_canal_length: values["irrigation_canal_length"],
          irrigation_canal_capacity: values["irrigation_canal_capacity"],
          canal_design: values["canal_design"],
          head_construction_design: values["head_construction_design"],
          maincanal_construction_num: values["maincanal_construction_num"],
          is_used: is_used === undefined ? false : is_used,
          usage_information: values["usage_information"],

          report_autor: values["report_autor"],
          report_name: values["report_name"],
          report_code: values["report_code"],
        };

        measurementDamCreate(newList)
      }
      // validation.resetForm();
    },
  });

  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Үгүй
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Тийм
      </div>
    );
  };

  return (

    <>
      <Row>
        <Col lg={12}>
          <div className="d-flex align-items-center mb-3">
            <img src={measurementSvg} alt="" height="50" />
            <div className="flex-grow-1 ms-3">
              <h5 className="fw-semibold">Мэдээлэл</h5>
              <ul className="list-unstyled hstack gap-2 mb-0">
                <li>
                  <i className="mdi mdi-table-row-height"></i>{" "}
                  <span className="text-muted fw-semibold">
                    Нийт: {meaCount}
                  </span>
                </li>
              </ul>
            </div>

            <button
              type="button"
              disabled={is_newCreated === true ? true : false}
              className="btn btn-success  btn-label"
              onClick={() => {
                validation.resetForm();
                setMeasurementDam(null);
                setIs_usedBoolean(false);
                setIs_newCreated(true);
              }}
            >
              <i className="mdi mdi-file-plus-outline label-icon"></i>
              Шинээр нэмэх
            </button>

          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={3}>
          <ul className="verti-timeline list-unstyled">
            {measurementList?.map((item, index) => (
              <li className="event-list active">
                <div className="event-timeline-dot">
                  <i className="bx bxs-right-arrow-circle font-size-18 bx-fade-right" />
                </div>
                <div className="flex-shrink-0 d-flex">
                  <div key={index} className="d-flex mb-3">
                    <div className="me-3">
                      <h5 className="font-size-14">
                        {item?.created_at.split("T")[0]}
                        <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                      </h5>
                    </div>
                    <div className="flex-grow-1">
                      <div>
                        <Link
                          to="#"
                          className="cursor fw-semibold"
                          onClick={() => {
                            setIs_newCreated(false)
                            setMeasurementDam(item)
                          }}
                        >
                          {item?.measure_date}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </Col>
        <Col lg={9}>
          {
            isLoading ? <Spinners setLoading={setLoading} sCustomTop={'120px'} /> :
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <Row>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Код </Label>
                      <Input
                        name="dam_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.dam_code || ""}
                        invalid={
                          validation.touched.dam_code &&
                            validation.errors.dam_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.dam_code &&
                        validation.errors.dam_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.dam_code}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Далангийн зохиомж </Label>
                      <Input
                        name="fiction"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.fiction || ""}
                        invalid={
                          validation.touched.fiction &&
                            validation.errors.fiction
                            ? true
                            : false
                        }
                      />
                      {validation.touched.fiction &&
                        validation.errors.fiction ? (
                        <FormFeedback type="invalid">
                          {validation.errors.fiction}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Далангийн бэхэлгээний төрөл </Label>
                      <Input
                        name="embankment_type"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.embankment_type || ""}
                        invalid={
                          validation.touched.embankment_type &&
                            validation.errors.embankment_type
                            ? true
                            : false
                        }
                      />
                      {validation.touched.embankment_type &&
                        validation.errors.embankment_type ? (
                        <FormFeedback type="invalid">
                          {validation.errors.embankment_type}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="fw-semibold"> Далангийн урт км </Label>
                      <Input
                        name="length"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.length || ""}
                        invalid={
                          validation.touched.length &&
                            validation.errors.length
                            ? true
                            : false
                        }
                      />
                      {validation.touched.length &&
                        validation.errors.length ? (
                        <FormFeedback type="invalid">
                          {validation.errors.length}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ус өнгөрүүлэх сувгийн урт  км </Label>
                      <Input
                        name="irrigation_canal_length"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.irrigation_canal_length || ""}
                        invalid={
                          validation.touched.irrigation_canal_length &&
                            validation.errors.irrigation_canal_length
                            ? true
                            : false
                        }
                      />
                      {validation.touched.irrigation_canal_length &&
                        validation.errors.irrigation_canal_length ? (
                        <FormFeedback type="invalid">
                          {validation.errors.irrigation_canal_length}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Суваг дээрх унтраах барилга байгууламжийн хийц </Label>
                      <Input
                        name="head_construction_design"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.head_construction_design || ""}
                        invalid={
                          validation.touched.head_construction_design &&
                            validation.errors.head_construction_design
                            ? true
                            : false
                        }
                      />
                      {validation.touched.head_construction_design &&
                        validation.errors.head_construction_design ? (
                        <FormFeedback type="invalid">
                          {validation.errors.head_construction_design}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ашиглалтын талаарх мэдээлэл </Label>
                      <Input
                        name="usage_information"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.usage_information || ""}
                        invalid={
                          validation.touched.usage_information &&
                            validation.errors.usage_information
                            ? true
                            : false
                        }
                      />
                      {validation.touched.usage_information &&
                        validation.errors.usage_information ? (
                        <FormFeedback type="invalid">
                          {validation.errors.usage_information}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Тайлангийн дугаар </Label>
                      <Input
                        name="report_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_code || ""}
                        invalid={
                          validation.touched.report_code &&
                            validation.errors.report_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_code &&
                        validation.errors.report_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_code}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Бүртгэл хийсэн огноо </Label>
                      <Flatpickr
                        className="form-control d-block"
                        placeholder="Огноо"
                        name="measure_date"
                        value={validation.values.measure_date}
                        onChange={(selectDate: Date[]) => {
                          if (selectDate[0]) {
                            const localDate = new Date(selectDate[0].getTime() - selectDate[0].getTimezoneOffset() * 60000)
                              .toISOString()
                              .split('T')[0];
                            validation.setFieldValue('measure_date', localDate);
                          }
                        }}
                        options={{
                          altInput: true,
                          altFormat: "Y-m-d",
                          dateFormat: "Y-m-d",
                          enableTime: false,
                        }}
                      />
                      {validation.touched.measure_date &&
                        validation.errors.measure_date ? (
                        <FormFeedback type="invalid">
                          {validation.errors.measure_date}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Дээд налуугийн хэмжээ </Label>
                      <Input
                        name="flooddam_head_degree"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.flooddam_head_degree || ""}
                        invalid={
                          validation.touched.flooddam_head_degree &&
                            validation.errors.flooddam_head_degree
                            ? true
                            : false
                        }
                      />
                      {validation.touched.flooddam_head_degree &&
                        validation.errors.flooddam_head_degree ? (
                        <FormFeedback type="invalid">
                          {validation.errors.flooddam_head_degree}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Далангийн бэхэлгээний хийц, хэмжээ </Label>
                      <Input
                        name="embankment_design"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.embankment_design || ""}
                        invalid={
                          validation.touched.embankment_design &&
                            validation.errors.embankment_design
                            ? true
                            : false
                        }
                      />
                      {validation.touched.embankment_design &&
                        validation.errors.embankment_design ? (
                        <FormFeedback type="invalid">
                          {validation.errors.embankment_design}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Өндөр м </Label>
                      <Input
                        name="heigth"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.heigth || ""}
                        invalid={
                          validation.touched.heigth &&
                            validation.errors.heigth
                            ? true
                            : false
                        }
                      />
                      {validation.touched.heigth &&
                        validation.errors.heigth ? (
                        <FormFeedback type="invalid">
                          {validation.errors.heigth}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Сувгийн үерийн ус өнгөрүүлэх чадвар м3/с </Label>
                      <Input
                        name="irrigation_canal_capacity"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.irrigation_canal_capacity || ""}
                        invalid={
                          validation.touched.irrigation_canal_capacity &&
                            validation.errors.irrigation_canal_capacity
                            ? true
                            : false
                        }
                      />
                      {validation.touched.irrigation_canal_capacity &&
                        validation.errors.irrigation_canal_capacity ? (
                        <FormFeedback type="invalid">
                          {validation.errors.irrigation_canal_capacity}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Тоо, шир </Label>
                      <Input
                        name="maincanal_construction_num"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.maincanal_construction_num || ""}
                        invalid={
                          validation.touched.maincanal_construction_num &&
                            validation.errors.maincanal_construction_num
                            ? true
                            : false
                        }
                      />
                      {validation.touched.maincanal_construction_num &&
                        validation.errors.maincanal_construction_num ? (
                        <FormFeedback type="invalid">
                          {validation.errors.maincanal_construction_num}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Тайлан гаргасан </Label>
                      <Input
                        name="report_autor"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_autor || ""}
                        invalid={
                          validation.touched.report_autor &&
                            validation.errors.report_autor
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_autor &&
                        validation.errors.report_autor ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_autor}
                        </FormFeedback>
                      ) : null}
                    </div>



                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Далангийн хийц </Label>
                      <Input
                        name="design"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.design || ""}
                        invalid={
                          validation.touched.design &&
                            validation.errors.design
                            ? true
                            : false
                        }
                      />
                      {validation.touched.design &&
                        validation.errors.design ? (
                        <FormFeedback type="invalid">
                          {validation.errors.design}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Доод налуугийн хэмжээ </Label>
                      <Input
                        name="flooddam_footer_degree"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.flooddam_footer_degree || ""}
                        invalid={
                          validation.touched.flooddam_footer_degree &&
                            validation.errors.flooddam_footer_degree
                            ? true
                            : false
                        }
                      />
                      {validation.touched.flooddam_footer_degree &&
                        validation.errors.flooddam_footer_degree ? (
                        <FormFeedback type="invalid">
                          {validation.errors.flooddam_footer_degree}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Үерийн ус зайлуулах сувгийн доторлогооны төрөл </Label>
                      <Input
                        name="flooddrain_type"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.flooddrain_type || ""}
                        invalid={
                          validation.touched.flooddrain_type &&
                            validation.errors.flooddrain_type
                            ? true
                            : false
                        }
                      />
                      {validation.touched.flooddrain_type &&
                        validation.errors.flooddrain_type ? (
                        <FormFeedback type="invalid">
                          {validation.errors.flooddrain_type}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Үерийн ус өнгөрүүлэх сувгийн хийц зохиомж </Label>
                      <Input
                        name="floodwater_canal_design"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.floodwater_canal_design || ""}
                        invalid={
                          validation.touched.floodwater_canal_design &&
                            validation.errors.floodwater_canal_design
                            ? true
                            : false
                        }
                      />
                      {validation.touched.floodwater_canal_design &&
                        validation.errors.floodwater_canal_design ? (
                        <FormFeedback type="invalid">
                          {validation.errors.floodwater_canal_design}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Сувгийн хийц, зохиомж </Label>
                      <Input
                        name="canal_design"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.canal_design || ""}
                        invalid={
                          validation.touched.canal_design &&
                            validation.errors.canal_design
                            ? true
                            : false
                        }
                      />
                      {validation.touched.canal_design &&
                        validation.errors.canal_design ? (
                        <FormFeedback type="invalid">
                          {validation.errors.canal_design}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ашиглаж байгаа эсэх </Label> <br />
                      <Switch
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        className="me-1 mb-sm-8 mb-2 ms-3"
                        onColor="#626ed4"
                        onChange={() => {
                          setIs_usedBoolean(!is_used);
                        }}
                        checked={is_used}
                      />
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Тайлангийн нэр </Label>
                      <Input
                        name="report_name"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_name || ""}
                        invalid={
                          validation.touched.report_name &&
                            validation.errors.report_name
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_name &&
                        validation.errors.report_name ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_name}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>

                  <Col lg={12} className="d-flex justify-content-center mt-3">
                    <button type="submit" className="btn btn-primary"> Хадгалах </button>
                  </Col>
                </Row>
              </Form>
          }
        </Col>
      </Row>

    </>
  )
}

export default Measurement;